var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 78,
    viewBox: "0 0 69 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8052 33.0547H52.7694H48.7338H44.6981H40.5182H36.4826H32.447H28.4113H24.3756H20.3401H16.1603H12.1246H8.08904H3.92188V37.1713H8.08904H12.1246H16.1603H20.3401H24.3756H28.3273V41.0342V45.214V49.325H32.3459V45.214V41.0342V37.1713H36.3645V41.0342V45.214V49.325H40.4811V45.214V41.0342V37.1713H44.6981H48.7338H52.7694H56.8052H60.8407H64.7885V33.0547H60.8407H56.8052Z",
    fill: "#2D6D44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.726 12.7656H48.6094V16.6862H52.726V12.7656Z",
    fill: "#2D6D44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6117 20.8982V16.6836H44.6936H40.4766V20.8982H44.6936H48.6117Z",
    fill: "#2D6D44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3594 61.501V65.5365V69.5721V73.7307H40.476V69.5721V65.5365V61.501V57.3623H44.693H48.7286H52.7643H56.8001H60.7648V53.3438H56.8001H52.7643H48.7286H44.693H40.5131H36.3594V57.3212V61.501Z",
    fill: "#2D6D44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3545 49.3281H32.3359V53.3467H36.3545V49.3281Z",
    fill: "#2D6D44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4477 24.9209H36.4834H40.4819V20.9023H36.4834H32.4477H28.3281V24.9209H32.4477Z",
    fill: "#2D6D44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3727 53.3438H20.3371H16.1573H12.1216H7.9375V57.3623H12.1216H16.1573H20.3371H24.3727H28.3244V61.501V65.5365V69.5721V73.7307H32.343V69.5721V65.5365V61.501V57.3212V53.3438H28.4084H24.3727Z",
    fill: "#2D6D44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3787 20.8982H28.3305V16.6836H24.3787H20.1953V20.8982H24.3787Z",
    fill: "#2D6D44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1869 12.7656H16.0703V16.6862H20.1869V12.7656Z",
    fill: "#2D6D44"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7649 57.3633H48.7292H44.6936H40.4766V61.5019V65.5374V69.615H44.6936H48.7292H52.7649H56.8007H60.7655V65.5374V61.5019V57.3633H56.8007H52.7649Z",
    fill: "#EF5050"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7649 41.0938H48.7292H44.6936H40.4766V45.2159V49.3269H44.6936H48.7292H52.7649H56.8007H60.7655V45.2159V41.0938H56.8007H52.7649Z",
    fill: "#EF5050"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3371 57.3633H16.1573H12.1216H7.9375V61.5019V65.5374V69.615H12.1216H16.1573H20.3371H24.3727H28.3244V65.5374V61.5019V57.3633H24.3727H20.3371Z",
    fill: "#EF5050"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3371 41.0938H16.1573H12.1216H7.9375V45.2159V49.3269H12.1216H16.1573H20.3371H24.3727H28.3244V45.2159V41.0938H24.3727H20.3371Z",
    fill: "#EF5050"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8052 24.918H52.7694H48.7338H44.6981H40.5182H36.4826H32.447H28.4113H24.3756H20.3401H16.1603H12.1246H8.08904H3.92188V28.9257V33.0531H8.08904H12.1246H16.1603H20.3401H24.3756H28.4113H32.447H36.4826H40.5182H44.6981H48.7338H52.7694H56.8052H60.8407H64.7885V28.9257V24.918H60.8407H56.8052Z",
    fill: "#70E08D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7643 49.3281H48.7286H44.693H40.5131H36.3594V53.3467H40.5131H44.693H48.7286H52.7643H56.8001H60.7648V49.3281H56.8001H52.7643Z",
    fill: "#70E08D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.726 8.64844H48.6094V12.765H52.726V8.64844Z",
    fill: "#70E08D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6117 8.65139V4.63281H44.6936H40.4766V8.65139H44.6936H48.6117Z",
    fill: "#70E08D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.476 12.7837V8.64844H36.3594V12.7837V16.6856H40.476V12.7837Z",
    fill: "#70E08D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3359 57.3212V61.501V65.5365V69.5721V73.7307H36.3545V69.5721V65.5365V61.501V57.3212V53.3438H32.3359V57.3212Z",
    fill: "#70E08D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3545 45.2146V41.0348V37.1719H32.3359V41.0348V45.2146V49.3256H36.3545V45.2146Z",
    fill: "#70E08D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3545 16.6836H32.3359V20.8982H36.3545V16.6836Z",
    fill: "#70E08D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4084 49.3281H24.3727H20.3371H16.1573H12.1216H7.9375V53.3467H12.1216H16.1573H20.3371H24.3727H28.4084H32.343V49.3281H28.4084Z",
    fill: "#70E08D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3281 16.6856H32.3467V12.7837V8.64844H28.3281V12.7837V16.6856Z",
    fill: "#70E08D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3305 8.65139V4.63281H24.3787H20.1953V8.65139H24.3787H28.3305Z",
    fill: "#70E08D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1869 8.64844H16.0703V12.765H20.1869V8.64844Z",
    fill: "#70E08D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7649 69.6133H48.7292H44.6936H40.4766V73.7299H44.6936H48.7292H52.7649H56.8007H60.7655V69.6133H56.8007H52.7649Z",
    fill: "#822A2A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7649 37.1719H48.7292H44.6936H40.4766V41.0924H44.6936H48.7292H52.7649H56.8007H60.7655V37.1719H56.8007H52.7649Z",
    fill: "#822A2A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3371 69.6133H16.1573H12.1216H7.9375V73.7299H12.1216H16.1573H20.3371H24.3727H28.3244V69.6133H24.3727H20.3371Z",
    fill: "#822A2A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3371 37.1719H16.1573H12.1216H7.9375V41.0924H12.1216H16.1573H20.3371H24.3727H28.3244V37.1719H24.3727H20.3371Z",
    fill: "#822A2A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7656 41.0348V45.2146V49.2501V53.2858V57.3216V61.5014V65.5369V69.5725V73.7311H64.7842V69.5725V65.5369V61.5014V57.3216V53.2858V49.2501V45.2146V41.0348V37.1719H60.7656V41.0348Z",
    fill: "#111111"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8362 20.8982H56.8007H52.7283V16.6836H48.6117V20.8982H44.6936H40.4766V24.9168H44.6936H48.7292H52.7649H56.8007H60.8362H64.784V28.9245V32.9601V37.1685H68.9986V32.9601V28.9245V24.8887V20.8982H64.8718H60.8362Z",
    fill: "#111111"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7664 73.7305H48.7308H44.6952H40.5153H36.4797H32.444H28.4084H24.3727H20.3371H16.1573H12.1216H7.9375V77.749H12.1216H16.1573H20.3371H24.3727H28.4084H32.444H36.4797H40.5153H44.6952H48.7308H52.7664H56.8023H60.767V73.7305H56.8023H52.7664Z",
    fill: "#111111"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7266 16.6856H56.7451V12.7837V8.64844H52.7266V12.7837V16.6856Z",
    fill: "#111111"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.726 4.63281H48.6094V8.65139H52.726V4.63281Z",
    fill: "#111111"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6117 8.64844H44.6936H40.4766V12.7837V16.6856H44.6936H48.6117V12.7837V8.64844Z",
    fill: "#111111"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6117 4.63221V0.515625H44.6936H40.4766V4.63221H44.6936H48.6117Z",
    fill: "#111111"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.476 16.6836H36.3594V20.8982H40.476V16.6836Z",
    fill: "#111111"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.476 4.63281H36.3594V8.65139H40.476V4.63281Z",
    fill: "#111111"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3359 16.6856H36.3545V12.7837V8.64844H32.3359V12.7837V16.6856Z",
    fill: "#111111"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3467 16.6836H28.3281V20.8982H32.3467V16.6836Z",
    fill: "#111111"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3467 4.63281H28.3281V8.65139H32.3467V4.63281Z",
    fill: "#111111"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3305 16.6856V12.7837V8.64844H24.3787H20.1953V12.7837V16.6856H24.3787H28.3305Z",
    fill: "#111111"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3305 4.63221V0.515625H24.3787H20.1953V4.63221H24.3787H28.3305Z",
    fill: "#111111"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1869 4.63281H16.0703V8.65139H20.1869V4.63281Z",
    fill: "#111111"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0733 8.64844H12.0547V12.7837V16.6856H16.0733V12.7837V8.64844Z",
    fill: "#111111"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94045 65.5369V61.5014V57.3216V53.2858V49.2501V45.2146V41.0348V37.1719H3.92188V41.0348V45.2146V49.2501V53.2858V57.3216V61.5014V65.5369V69.5725V73.7311H7.94045V69.5725V65.5369Z",
    fill: "#111111"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92056 28.9245V24.9168H8.08772H12.1232H16.159H20.3388H24.3743H28.326V20.8982H24.3743H20.1909V16.6836H16.0743V20.8982H12.1232H8.08772H4.05199H0V24.8887V28.9245V32.9601V37.1685H3.92056V32.9601V28.9245Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.7e59169251af9f47e14b788679190d53.svg";
export { ForwardRef as ReactComponent };